import { render, staticRenderFns } from "./LoginEsqueceuSenha.vue?vue&type=template&id=8e7b6cfc&scoped=true"
import script from "./LoginEsqueceuSenha.vue?vue&type=script&lang=js"
export * from "./LoginEsqueceuSenha.vue?vue&type=script&lang=js"
import style0 from "./LoginEsqueceuSenha.vue?vue&type=style&index=0&id=8e7b6cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7b6cfc",
  null
  
)

export default component.exports